module.exports = __webpack_public_path__ + "img/img-service-03@2x.e6fa77cb.jpg";